function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("circle", {
  id: "clock-b",
  cx: 10,
  cy: 14,
  r: 10
}), React.createElement("filter", {
  id: "clock-a",
  width: "170%",
  height: "170%",
  x: "-35%",
  y: "-25%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(4 2)"
}, React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 3,
  d: "M15.0060345,1.99884499 C13.4652308,1.35538347 11.7741176,1 10,1 C8.22850212,1 6.53976354,1.35433472 5.00079197,1.99599646"
}), React.createElement("use", {
  fill: "#000",
  filter: "url(#clock-a)",
  xlinkHref: "#clock-b"
}), React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#clock-b"
}), React.createElement("polyline", {
  stroke: "#00143A",
  strokeWidth: 2,
  points: "10 7 10 14 14 19"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 30,
    viewBox: "0 0 28 30"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/clock.2ed81f54.svg";
export { SvgComponent as ReactComponent };